module.exports = ".issuealert{\r\n    background: #fbd7d7;\r\n    }\r\n\r\n.issue{\r\n    background: #d5ded6eb;\r\n}\r\n\r\ntd{\r\n    border: 1px solid rgb(179, 184, 247);\r\n    vertical-align: middle;\r\n    font-size:14px !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/issues/external-issues-grid/external-issues-grid.component.css
// module id = ./src/app/issues/external-issues-grid/external-issues-grid.component.css
// module chunks = main